var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.825V22.325C3.5 22.4576 3.55268 22.5848 3.64645 22.6786C3.74021 22.7723 3.86739 22.825 4 22.825H20C20.1326 22.825 20.2598 22.7723 20.3536 22.6786C20.4473 22.5848 20.5 22.4576 20.5 22.325V13.325",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.325L11.4 1.42503C11.4784 1.3466 11.5714 1.28438 11.6739 1.24193C11.7763 1.19948 11.8861 1.17763 11.997 1.17763C12.1079 1.17763 12.2177 1.19948 12.3201 1.24193C12.4226 1.28438 12.5156 1.3466 12.594 1.42503L23.494 12.325",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.825V15.488C14.266 15.1248 14.8741 14.4959 15.2115 13.7181C15.5488 12.9403 15.5923 12.0665 15.334 11.259L14.134 12.448C13.8986 12.6815 13.5801 12.812 13.2485 12.8107C12.9169 12.8094 12.5995 12.6764 12.366 12.441C12.1324 12.2056 12.002 11.8871 12.0033 11.5556C12.0046 11.224 12.1376 10.9065 12.373 10.673L13.759 9.30002C13.3509 9.06258 12.8991 8.91013 12.4306 8.85185C11.9621 8.79357 11.4867 8.83066 11.033 8.9609C10.5792 9.09114 10.1565 9.31182 9.79022 9.60968C9.42396 9.90754 9.12175 10.2764 8.90177 10.6941C8.68178 11.1118 8.54857 11.5697 8.51015 12.0402C8.47172 12.5107 8.52889 12.9842 8.67819 13.432C8.82749 13.8799 9.06586 14.2929 9.37893 14.6462C9.69201 14.9995 10.0733 15.2859 10.5 15.488V20.825",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.c925890920584407d80706ba71eb6a8f.svg";
export { ForwardRef as ReactComponent };